





































































































import { Component, Emit, Prop, Ref, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { DataTable, Col } from '@/components/molecules/DataTable'
import { defaultTrader, Trader } from '@/api'
import { dataStore, traderStore } from '@/utils/store-accessor'
import { cloneDeep } from 'lodash'
import { AtomTextField } from '@/components/atoms'

interface SelectTrader extends Trader {
  isSelected: boolean
}

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: 80,
    resizable: true,
    movable: false,
    items: [
      {
        name: 'code',
        headerText: 'code'
      }
    ]
  },
  {
    width: '70',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'name',
        headerText: '正式形'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'shortName',
        headerText: '省略形'
      }
    ]
  }
]

interface FilterCondition {
  code: string
  name: string
}

const defaultFilterCondition = (): FilterCondition => ({
  code: '',
  name: ''
})

@Component({
  components: {
    ModalFooter,
    DataTable
  }
})
export default class ModalTrader extends ModalComponentBaseVue {
  @Ref()
  codeTextField!: AtomTextField

  @Ref()
  nameTextField!: AtomTextField

  @Prop({
    type: Array
  })
  defaultCodes!: string[]

  @Prop({
    type: Boolean,
    default: false
  })
  multiple!: boolean

  dialog: boolean = false

  isAllSelect: boolean = false

  tableBodyHeight: number = 0

  traders: SelectTrader[] = []

  filterCondition: FilterCondition = defaultFilterCondition()

  // codeKeyが固定なのでcountも固定とする
  get codeMask(): string {
    return 'X'.repeat(4)
  }

  get cols(): Col[] {
    if (this.multiple) {
      const cols: Col[] = cloneDeep(COLS)
      cols[0].items[0].name = 'check'
      return cols
    }

    return COLS
  }

  get countOfTraders(): number {
    return this.filteredTraders.length
  }

  get countOfSelectedTraders(): number {
    return this.filteredTraders.filter(trader => trader.isSelected).length
  }

  get filteredTraders(): SelectTrader[] {
    const codeRegExp = new RegExp(`^${this.filterCondition.code}`)
    const nameRegExp = new RegExp(`${this.filterCondition.name}`)

    return this.traders.filter(
      trader =>
        (this.filterCondition.code === '' || trader.code.match(codeRegExp)) &&
        (this.filterCondition.name === '' ||
          trader.name.match(nameRegExp) ||
          trader.shortName.match(nameRegExp))
    )
  }

  @Watch('filteredTraders')
  onFiltered(newVal: SelectTrader[]): void {
    this.traders.forEach(
      trader =>
        (trader.isSelected =
          trader.isSelected && newVal.some(value => value.code === trader.code))
    )

    if (!this.multiple && newVal.every(trader => !trader.isSelected)) {
      newVal.forEach(
        (trader: SelectTrader, index: number) =>
          (trader.isSelected = index === 0)
      )
    }
  }

  @Watch('dialog')
  onShowChanged(val: boolean) {
    val ? this.opened() : this.closed()
  }

  @Watch('isAllSelect')
  toggleSelected(newVal: boolean): void {
    this.filteredTraders.forEach(trader => {
      trader.isSelected = newVal
    })
  }

  mounted() {
    this.debug('mounted()')
    window.addEventListener('resize', this.calculateTableHeight)
  }

  beforeDestroy() {
    this.debug('beforeDestroy()')
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  open(): void {
    this.dialog = true
    this.$nextTick(() => {
      this.calculateTableHeight()
      setTimeout(this.focus)
    })
  }

  focus(): void {
    if (dataStore.systemCodeDialogInitialFocusName) {
      this.nameTextField.atomTextField.focus()
    } else {
      this.codeTextField.atomTextField.focus()
    }
  }

  close(): void {
    this.dialog = false
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onClickOk(): void {
    this.$emit(
      'ok',
      this.multiple
        ? this.filteredTraders.filter(trader => trader.isSelected)
        : this.filteredTraders.find(trader => trader.isSelected) ??
            defaultTrader()
    )
    this.close()
  }

  onClickCancel(): void {
    this.$emit('cancel')
    this.close()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-trader')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onRowClick(index: number): void {
    if (this.multiple) {
      this.filteredTraders[index].isSelected = !this.filteredTraders[index]
        .isSelected
      return
    }

    this.filteredTraders.forEach(
      trader =>
        (trader.isSelected = trader.id === this.filteredTraders[index].id)
    )
  }

  onRowDblclick(): void {
    if (this.multiple) return
    this.onClickOk()
  }

  toggleAllSelect(val: boolean): void {
    this.isAllSelect = val
  }

  @Emit('opened')
  opened(): void {
    this.traders = traderStore.allItems.map((item, index) => {
      const existsCode: boolean = this.defaultCodes.some(
        code => code.trim() === item.code
      )
      return {
        ...item,
        // 空白があっても対応できるようにしている
        isSelected: this.multiple || existsCode ? existsCode : index === 0
      }
    })
  }

  @Emit('closed')
  closed(): void {
    this.traders = []
    this.isAllSelect = false
    this.filterCondition = defaultFilterCondition()
  }
}
